// The browser half of ./sentry, selected by the `browser` field map in package.json.
//
// @sentry/browser, not @sentry/react: the logger uses neither the React error boundary nor the router
// instrumentation, and @sentry/react peers on React, which the api has no reason to install.
//
// The SDK keys its global carrier on the exact version string, so this package and whichever browser
// SDK the app initialises MUST hold the same version. Drift means a capture here reaches a client
// nobody configured, and nothing reports the loss. __tests__/carrier-version.test.js is that gate.
module.exports = require('@sentry/browser');
